import { useState } from 'react';
import { Grid, Link, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useIsOperator } from 'features/auth/hooks/useIsOperator';
import MetricTrackerTable from './MetricTrackerTable';
import MetricCalculator from './MetricCalculator';
import { useIsAdmin } from 'features/auth/hooks/useIsAdmin';
import StorageIcon from '@mui/icons-material/Storage';

const MetricTrackerWidget = () => {
  const [metricCalculatorOpen, setMetricCalculatorOpen] =
    useState<boolean>(false);
  const isOperator = useIsOperator();
  const isAdmin = useIsAdmin();

  if (!isOperator) return <></>;

  return (
    <>
      <MetricCalculator
        open={metricCalculatorOpen}
        handleClose={() => setMetricCalculatorOpen(false)}
      />
      <Grid item container component={Paper} justifyContent={'center'}>
        <Grid
          container
          item
          alignItems='center'
          justifyContent='center'
          spacing={1}
          xs={12}
        >
          <Grid item>
            <StorageIcon style={{ verticalAlign: 'middle' }} />
          </Grid>
          <Grid item>
            <Typography variant='h6'>Data Metrics</Typography>
          </Grid>
        </Grid>
        {isAdmin && (
          <Grid container alignItems='center' justifyContent='center'>
            <Grid item xs={2}>
              <Link
                component='button'
                variant='body2'
                onClick={() => setMetricCalculatorOpen(true)}
              >
                Calculator
              </Link>
            </Grid>
            <Grid item xs={3}>
              <Link variant='body2' component={RouterLink} to='/system-info'>
                Adjust Purge Time
              </Link>
            </Grid>
          </Grid>
        )}
        <Grid container item>
          <MetricTrackerTable />
        </Grid>
      </Grid>
    </>
  );
};

export default MetricTrackerWidget;
